import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {BaseRequest} from "../utils/Classes/Requests/BaseRequest";
import axios from "axios";
import TS from '../utils/TimeStampGenerator'
import {config} from "../utils/Constants";

const URL = config.url;
const REQUEST_CARD_TYPE_ID = 1;

const getAuthorizationAdditionalInfo = (params) => {
    if (params?.typeId === REQUEST_CARD_TYPE_ID) {
        return "{}";
    }

    return typeof params?.additionalData === "string"
        ? params.additionalData
        : JSON.stringify(params?.additionalData || {});
};

const initialState = {
    authorizationCode: "",
    qrData: "",
    status: "",
    qrTimeout: false,
    loading: "idle",
    opLoading: "idle",
    actionType: "",
    actionPayload: null,
    validationInfo: null, //to add some data on the portal action qr
    bankValidationInfo: null,
    additionalData: null, //to send additional data in reload qr
    error: null,
};

export const generateAuthorizationCode = createAsyncThunk(
    "Authorization/GenerateAuthorizationQrCode",
    async (params=null) => {
        const res = await axios.post(
            `${URL}/v1/Authorization/GenerateAuthorizationQrCode`,
            {
                SessionID: sessionStorage.getItem("SessionID"),
                TypeID: params?.typeId,
                AdditionalInfo: getAuthorizationAdditionalInfo(params),
            },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: sessionStorage.getItem("Token"),
                }
            }
        );
        return res.data;
    }
);


export const checkAuthorizationStatus = createAsyncThunk(
    "Authorization/CheckAuthorizationQrCode",
    async (params) => {
        const {authCode, controller} = params;
        // axios.defaults.signal = controller.signal;
        if (authCode && authCode.length > 0) {
            try {
                const res = await axios.post(
                    `${URL}/v1/Authorization/PortalActionsAuthorizationStatus`,
                    {
                        //Body
                        SessionID: sessionStorage.getItem("SessionID"),
                        TS: TS(),
                        AuhtorizationCode: authCode,
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: sessionStorage.getItem("Token"),
                        },
                        signal: controller.signal
                    }
                );
                const status = res.data.Payload.Status;
                return status;
            } catch (e) {
                throw e;
            }

        }
    }
);

export const getExpAuthCodeOnClose = createAsyncThunk(
    "Authorization/ExpireAuthorizationCodeOnClose",
    async (params) => {
        const {authCode} = params;
        await axios.post(
            `${URL}/v1/Authorization/ExpireAuthorizationCodeOnClose`,
            {
                SessionID: sessionStorage.getItem("SessionID"),
                TS: TS(),
                AuthorizationCode: authCode,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: sessionStorage.getItem("Token"),
                }
            }
        );
    }
);

const authorizationCodeSlice = createSlice({
    name: "authorizationCode",
    initialState,
    reducers: {
        setAuthorizationCode: (state, action) => {
            state.authorizationCode = action.payload;
        },
        setQrData: (state, action) => {
            state.qrData = action.payload;
        },
        setStatus: (state, action) => {
            state.status = action.payload;
        },
        setOpLoading: (state, action) => {
            state.opLoading = action.payload;
        },
        setAuthorizationCodeStatus: (state, action) => {
            state.status = action.payload;
        },
        setQrTimeout: (state, action) => {
            state.qrTimeout = action.payload;
        },
        setActionType: (state, action) => {
            state.actionType = action.payload;
        },
        setActionPayload: (state, action) => {
            state.actionPayload = action.payload;
        },
        setValidationInfo: (state, action) => {
            state.validationInfo = action.payload;
        },
        setBankValidationInfo: (state, action) => {
            state.bankValidationInfo = action.payload;
        },
        setAdditionalData: (state, action) => {
            state.additionalData = action.payload;
        },
        resetState: (state) => {
            state = {...initialState};
        }
    },
    extraReducers: (builder) => {
        builder.addCase(generateAuthorizationCode.pending, (state) => {
            if (state.loading === "idle") state.loading = "pending";
            state.error = null;
        });
        builder.addCase(
            generateAuthorizationCode.fulfilled,
            (state, action) => {
                if (state.loading === "pending") {
                    state.loading = "idle";
                    state.qrData = action.payload.Payload.QrCode;
                    state.authorizationCode = action.payload.Payload.AuthorizationCode;
                    state.qrTimeout = false;
                    state.error = null;
                }
            }
        );
        builder.addCase(generateAuthorizationCode.rejected, (state, action) => {
            if (state.loading === "pending") {
                state.qrData = "";
                state.authorizationCode = "";
                state.loading = "idle";
                state.error = action.error;
            }
        });
        builder.addCase(
            checkAuthorizationStatus.fulfilled,
            (state, action) => {
                state.status = action.payload;
                // state.qrTimeout = !(action.payload === "PENDING")
            }
        );
        builder.addCase(checkAuthorizationStatus.rejected, (state, action) => {
            state.qrData = "";
            state.authorizationCode = "";
            state.qrTimeout = true;
            state.error = action.error;
        });
    },
});

export const {
    setActionType,
    setActionPayload,
    setAuthorizationCode,
    setQrTimeout,
    setQrData,
    setStatus,
    setOpLoading,
    setValidationInfo,
    setBankValidationInfo,
    setAdditionalData,
    resetState
} = authorizationCodeSlice.actions;

export default authorizationCodeSlice.reducer;
